import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import CertificationSupplierEditModal from '../../CertificationSuppliers/Elements/CertificationSupplierEditModal';

class CertificationSuppliersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      certification_suppliers: null,
      certifications: [],
      data_certification_supplier: [],
      id: this.props.certification_id,
    };

    //bind específico
    this.addSupplier = this.addSupplier.bind(this);
    this.deleteSupplier = this.deleteSupplier.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.supplier_id !== 'undefined' && Array.isArray(newProps.certifications) && Array.isArray(newProps.certification_suppliers) && this.state.loaded === 0) {
      this.setState({
        id: newProps.supplier_id,
        certifications: newProps.certifications,
        certification_suppliers: newProps.certification_suppliers,
        loaded: 1,
      });
    }
  }
  
  addSupplier(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      certification_id: this.state.certification_id,
      supplier_id: this.state.id,
      anac_code: this.state.anac_code,
      expiration: this.state.expiration,
      certificate: this.state.certificate,
      returning_deadline: this.state.returning_deadline,
      hour_value: this.state.hour_value,
      contact_name: this.state.contact_name,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/fornecedor', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({certification_suppliers: responseJson.data});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteSupplier (event) {
    var certification_supplier_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse fornecedor?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado/fornecedor/' + certification_supplier_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(certification_supplier_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(certification_supplier_id) {
    var certification_suppliers = this.state.certification_suppliers;
    certification_suppliers.map(function(dado, index){
      if (dado.id == certification_supplier_id) {
        certification_suppliers.splice(index, 1);
      }
    });
    this.setState({certification_suppliers: certification_suppliers});
  }

  loadData (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/certificado/fornecedor/editar/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_certification_supplier:responseJson.data.main});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/fornecedores/certificados/'+self.props.supplier_id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certification_suppliers: responseJson.data});
          self.props.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div>
    <h4>Adicionar fornecedor</h4>
    <hr/>
    <form onSubmit={this.addSupplier}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Certificado:</label>
            <Select
              className="form-field-name"
              name="certification_id"
              value={this.state.certification_id}
              searchable={true}
              placeholder={'Selecionar Certificado'}
              onChange={this.handleSelectChange.bind(this, 'certification_id')}
              options={this.state.certifications}
            />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Código ANAC:</label>
            <input type="text" name="anac_code" className="form-control" placeholder="" value={this.state.anac_code} onChange={this.handleChange.bind(this, 'anac_code')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Expiração:</label>
            <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Certificação:</label>
            <input type="text" name="certificate" className="form-control" placeholder="" value={this.state.certificate} onChange={this.handleChange.bind(this, 'certificate')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Prazo para Cancelamento com Retorno do Pagamento (em dias):</label>
            <InputMask value={this.state.returning_deadline}  maskChar={null} name="returning_deadline" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'returning_deadline')} placeholder="" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Contato nome:</label>
            <input type="text" name="contact_name" className="form-control" placeholder="" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
          </div>
        </div>
      </div>  
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Telefone:</label>
            <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do fornecedor" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>E-mail:</label>
            <input type="text" name="email" className="form-control" placeholder="E-mail do fornecedor" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Valor Hora:</label>
            <InputMask value={this.state.hour_value}  maskChar={null} name="hour_value" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Observações:</label>
            <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar fornecedor</button>
        </div>
      </div>
    </form>
  </div>
  <CertificationSupplierEditModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} data_certification_supplier={self.state.data_certification_supplier} refreshTable={self.refreshTable} />
  <hr/>
  <div>
    {(this.state.certification_suppliers === null || typeof this.state.certification_suppliers === 'undefined') ?  '' 
    : 
      <table className="table">
        <thead>
          <tr>
            <th>
              Certificado
            </th>
            <th>
              Telefone
            </th>
            <th>
              Expiração
            </th>
            <th>
              Custo/H
            </th>
            <th>
              Reembolso
            </th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody id="certifications-certifications">
          {Object.keys(self.state.certification_suppliers).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.certification_suppliers[k].certification_name}
                </td>
                <td>
                  {self.state.certification_suppliers[k].phone}
                </td>
                <td>
                  {self.state.certification_suppliers[k].expiration_str}
                </td>
                <td>
                  {self.state.certification_suppliers[k].hour_value}
                </td>
                <td>
                  {self.state.certification_suppliers[k].returning_deadline}
                </td>
                <td>
                  <div className="btn-group">
                    <button onClick={self.loadData.bind(self, self.state.certification_suppliers[k])} className='btn btn-sm btn-primary' alt='Editar' title='Editar'><i className="fa fa-fw fa-pencil"></i></button>
                    <button className="btn btn-sm btn-danger" value={self.state.certification_suppliers[k].id} onClick={self.deleteSupplier}>
                      <i className="fa fa-fw fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    }
  </div>
</div>
    );
  }
}

export default CertificationSuppliersTab;



// WEBPACK FOOTER //
// ./src/Components/Suppliers/Elements/SupplierCertificationsTab.js